module.exports = __webpack_public_path__ + "static/media/2.4 Heeremans Detail Schlitten_klein.00ae5479.jpg";